import axios from '../common/axios';

window.alert = function (
    message,
    status = "error",
    timeout = 2,
    position = "center"
) {
    const statuss = {
        success: { bg: "#16a34a", icon: "✓" },
        error: { bg: "#dc2626", icon: "✕" },
        warning: { bg: "#f59e0b", icon: "!" },
        default: { bg: "#2563eb", icon: "i" },
    };
    const s = statuss[status] || statuss.default;

    if (window.dialog) window.dialog.remove();
    window.dialog = document.createElement("div");
    dialog.innerHTML = `
    <div class="alert-dialog alert-${status} fadein" style="--alert-bg:${s.bg}" role="alert">
      <span class="alert-icon">${s.icon}</span>
      <span class="alert-msg">${message}</span>
      <span class="alert-close" aria-label="close">&times;</span>
      <span class="alert-progress"></span>
    </div>`;
    document.querySelector("body").append(window.dialog);

    const box = window.dialog.firstElementChild;
    const bar = box.querySelector(".alert-progress");
    const thisDialog = window.dialog;
    const totalMs = timeout * 1000;
    let autoHideTimer = null;
    let removeTimer = null;
    let remaining = totalMs;
    let startedAt = 0;

    const cancelTimers = () => {
        clearTimeout(autoHideTimer);
        clearTimeout(removeTimer);
    };

    const dismiss = () => {
        cancelTimers();
        box.classList.add("fadeout");
        removeTimer = setTimeout(() => thisDialog.remove(), 350);
    };

    const startAutoHide = () => {
        cancelTimers();
        startedAt = Date.now();
        autoHideTimer = setTimeout(dismiss, remaining);
        if (bar) {
            const pct = (remaining / totalMs) * 100;
            bar.style.transition = "none";
            bar.style.width = pct + "%";
            void bar.offsetWidth;
            bar.style.transition = "width " + remaining + "ms linear";
            bar.style.width = "0%";
        }
    };

    const pause = () => {
        cancelTimers();
        box.classList.remove("fadeout");
        remaining -= Date.now() - startedAt;
        if (remaining < 0) remaining = 0;
        if (bar) {
            const pct = (remaining / totalMs) * 100;
            bar.style.transition = "none";
            bar.style.width = pct + "%";
        }
    };

    box.addEventListener("mouseenter", pause);
    box.addEventListener("mouseleave", startAutoHide);
    box.querySelector(".alert-close").addEventListener("click", dismiss);

    startAutoHide();
};
const to = async (promise) => {
    try {
        const response = await promise;
        // console.log("Was in to 2", re);

        return response;
    } catch (error) {
        //Check statut
       // console.log('error--------',error.response.data)
        alert(error.response ? error.response.data : error.message)
        if(error.response && error.response.data === 'Login failed please try again'){
            window.localStorage.removeItem('id_token');
            window.location.href = '/';
        }
        return {}
    }
};


export default {
    // Generic GET/POST to an arbitrary "module/action" path (telephony, missedCalls…).
    // NB: the shared axios interceptor resolves with `undefined` for a body `status` of 400/401
    // (after alert()/logout), so never destructure the response here.
    customGet: async function (path, payload) {
        const res = await to(axios.get(path, { params: payload }))
        return (res && res.data) || null;
    },
    customPost: async function (path, payload) {
        const res = await to(axios.post(path, payload))
        return (res && res.data) || null;
    },
    //working
    get: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/get`, { params: payload }))
        if (!data) return null
        return data;
    },
    search: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/search`, { params: payload }))
        // console.log("kan hna", data)
        if (!data) return null
        return data;
    },
    bigSearch: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/search`, payload))
        // console.log("kan hna", data)
        if (!data) return null
        return data;
    },
    //working
    create: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/create`, payload))
        if (!data) return null
        return data;
    },
    insertMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/insertMany`, payload))
        if (!data) return null
        return data;
    },
    // working
    update: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/update?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    updateMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/updateMany`, payload))
        if (!data) return null
        return data;
    },
    deleteMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/deleteMany`, payload))
        if (!data) return null
        return data;
    },
    getOrdersByseller: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/getOrdersByseller`, payload))
        if (!data) return null
        return data;
    },
    //working
    delete: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/delete`, { params: payload }))
        if (!data) return null
        return data;
    },
    find: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/find`, { params: payload }))
        if (!data) return null
        return data;
    },
    login: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/login`, payload))
        if (!data) return null
        return data;
    },
    generateToken: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/generateToken`, payload))
        if (!data) return null
        return data;
    },
    forgotPassword: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/forgotPassword`, payload))
        if (!data) return null
        return data;
    },
    verificationCode: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/verificationCode`, payload))
        if (!data) return null
        return data;
    },
    verificationCodeSms: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/verificationCodeSms`, payload))
        if (!data) return null
        return data;
    },
    me: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/me`, { params: payload }))
        if (!data) return null
        return data;
    },
    import: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/import`, payload))
        if (!data) return null;
        return data;
    },
    confirmation: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/confirmation`, { params: payload }))
        if (!data) return null
        return data;
    },
    export: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/export`, { params: payload }))
        if (!data) return null
        return data;
    },
    convert: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/convert`, payload))
        if (!data) return null
        return data;
    },

    getOrders: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrders`, { params: payload }))
        if (!data) return null
        return data;
    },
    getRevenus_and_TopProducts_Stock: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getRevenus_and_TopProducts_Stock`, { params: payload }))
        if (!data) return null
        return data;
    },
    getOrdersBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrdersBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrders: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrders`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalSeller: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalSeller`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalProduct: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalProduct`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersPerTeleConsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersPerTeleConsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersTeleConsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersTeleConsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getOrdersTeleConsultantBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrdersTeleConsultantBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    CalculatePercentageStaus: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/CalculatePercentageStaus`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersPaid: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersPaid`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalStatusPerTeleconsultantBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalStatusPerTeleconsultantBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalStatusPerTeleconsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalStatusPerTeleconsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalDelivery: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalDelivery`, { params: payload }))
        if (!data) return null
        return data;
    },
    getConfirmationStatus: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getConfirmationStatus`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAllSeller: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAllSeller`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalFeesExpeditions: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalFeesExpeditions`, { params: payload }))
        if (!data) return null
        return data;
    },
    sendEmail: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/sendEmail`, payload))
        if (!data) return null
        return data;
    },
    sendEmails: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/sendEmails`, payload))
        if (!data) return null
        return data;
    },
    sendMessage: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/sendMessage?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    configureSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/configureSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    testSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/testSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    listSellerWebhooks: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/listSellerWebhooks`, payload))
        if (!data) return null
        return data;
    },
    addSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/addSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    updateSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/updateSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    deleteSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/deleteSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    // generic POST to /:module/:action  (used by auto-confirm scoring)
    action: async function (module, action, payload) {
        const { data } = await to(axios.post(`${module}/${action}`, payload))
        if (!data) return null
        return data;
    },
}